import { canonicalErrorSchema as e, uuidSchema as t } from "../common/index.js";
import * as n from "zod";
// src/phone/phone.schema.ts
var r = t, i = t, a = n.number().int().positive().max(2 ** 53 - 1), o = n.string().length(4).regex(/^[0-9]{4}$/), s = n.string().regex(/^\+[1-9][0-9]{1,14}$/), c = n.enum([
	"inboundGreeting",
	"clientCodePrompt",
	"beforeTransfer",
	"voicemailPrompt"
]);
function l(e) {
	return n.discriminatedUnion("mode", [
		n.strictObject({ mode: n.literal("default") }),
		n.strictObject({
			mode: n.literal("tts"),
			text: n.string().trim().min(1).max(e).refine((e) => e.isWellFormed() && !e.includes("\0"))
		}),
		n.strictObject({
			mode: n.literal("mp3"),
			assetId: i
		})
	]);
}
var u = n.discriminatedUnion("mode", [
	n.strictObject({ mode: n.literal("default") }),
	n.strictObject({
		mode: n.literal("tts"),
		text: n.string().trim().min(1).max(400).refine((e) => e.isWellFormed() && !e.includes("\0"))
	}),
	n.strictObject({
		mode: n.literal("mp3"),
		assetId: i
	})
]), d = n.strictObject({
	inboundGreeting: l(400),
	clientCodePrompt: l(80),
	beforeTransfer: l(80),
	voicemailPrompt: l(200)
}), f = n.strictObject({
	teamId: t,
	inboundNumber: s.nullable()
}), p = n.strictObject({
	version: n.number().int().nonnegative().max(2 ** 53 - 1),
	inboundNumber: s.nullable(),
	codeRequired: n.boolean(),
	messages: d
}), m = n.strictObject({
	id: i,
	ownerType: n.enum(["team", "customer"]),
	ownerId: t,
	slot: c,
	mimeType: n.literal("audio/mpeg"),
	sizeBytes: n.number().int().positive().max(1048576),
	durationMs: n.number().int().positive().max(6e4),
	digest: n.string().regex(/^[a-f0-9]{64}$/)
}), h = p.extend({
	teamId: t,
	assets: n.array(m).max(4)
}), g = n.strictObject({
	version: a,
	clientCode: o,
	recognizedCallerGreeting: u.nullable()
}), _ = g.extend({
	customerId: t,
	status: n.enum(["active", "archived"]),
	assets: n.array(m).max(1)
}), v = n.iso.datetime({ offset: !0 }), y = n.strictObject({
	id: t,
	name: n.string().min(1).max(250)
}), b = n.enum([
	"no-eligible-agent",
	"unavailable",
	"setup-failed",
	"submission-unknown",
	"busy",
	"no-answer",
	"acceptance-expired",
	"declined",
	"caller-ended",
	"agent-ended",
	"preparation-expired",
	"handoff-unavailable"
]), x = n.discriminatedUnion("kind", [
	n.strictObject({ kind: n.literal("preparing") }),
	n.strictObject({
		kind: n.literal("ringing"),
		ringingAt: v
	}),
	n.strictObject({
		kind: n.literal("accepted-waiting"),
		acceptedAt: v
	}),
	n.strictObject({
		kind: n.literal("connected"),
		acceptedAt: v,
		connectedAt: v
	}),
	n.strictObject({
		kind: n.literal("ended"),
		endedAt: v,
		connectedAt: v.nullable()
	}),
	n.strictObject({
		kind: n.literal("voicemail-required"),
		reason: b
	}),
	n.strictObject({
		kind: n.literal("handoff-unavailable"),
		reason: n.literal("handoff-unavailable")
	})
]), S = n.strictObject({
	method: n.enum([
		"number",
		"code",
		"manual"
	]).nullable(),
	outcome: n.enum([
		"matched",
		"unknown",
		"withheld",
		"invalid",
		"archived-only",
		"ambiguous",
		"unavailable"
	]),
	customer: y.nullable()
}), C = n.discriminatedUnion("kind", [n.strictObject({
	kind: n.literal("no-phone"),
	incidentId: t
}), n.strictObject({
	kind: n.literal("phone"),
	callId: r,
	incidentId: t,
	version: a,
	receivedAt: v,
	callerNumber: s.nullable(),
	callerNumberOutcome: n.enum([
		"available",
		"withheld",
		"invalid",
		"unavailable"
	]),
	dialedNumber: s.nullable(),
	originalTeam: y.nullable(),
	selectedAgent: y.nullable(),
	identification: S,
	stage: x,
	failureReason: b.nullable(),
	voicemailHandoffUnavailable: n.boolean()
})]), w = n.strictObject({
	kind: n.literal("unavailable"),
	reason: n.literal("recording-unavailable")
}), T = e.omit({ details: !0 }).extend({ fieldErrors: n.partialRecord(n.enum([
	"inboundNumber",
	"codeRequired",
	"messages",
	"inboundGreeting",
	"clientCodePrompt",
	"beforeTransfer",
	"voicemailPrompt",
	"clientCode",
	"recognizedCallerGreeting",
	"assetId",
	"version",
	"customerId"
]), n.enum([
	"Invalid value.",
	"Value is out of range.",
	"Value is already in use.",
	"Unsupported field."
])).optional() }), E = n.strictObject({
	ownerType: n.enum(["team", "customer"]),
	ownerId: t,
	slot: c
});
export { r as phoneCallIdSchema, s as phoneCanonicalNumberSchema, o as phoneClientCodeSchema, _ as phoneCustomerSettingsSchema, g as phoneCustomerSettingsUpdateSchema, T as phoneErrorSchema, b as phoneFailureReasonSchema, S as phoneIdentificationSchema, u as phoneMessageChoiceSchema, c as phoneMessageSlotSchema, C as phoneProgressSchema, x as phoneProgressStageSchema, i as phonePromptAssetIdSchema, m as phonePromptAssetMetadataSchema, E as phonePromptAssetUploadQuerySchema, w as phoneRecordingHandoffResultSchema, d as phoneTeamMessagesSchema, f as phoneTeamNumberSchema, h as phoneTeamSettingsSchema, p as phoneTeamSettingsUpdateSchema, a as phoneVersionSchema };

//# sourceMappingURL=phone.schema.js.map